module.exports = "/assets/fbc363caad514edd4586d936a0e2664d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3U.png
// module id = 1021
// module chunks = 0